var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarehousing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.548828,
    y: 0.220703,
    width: 44,
    height: 44,
    rx: 10,
    fill: "#FCDFD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5488 29.2207H33.5488V31.2207H11.5488V29.2207H13.5488V14.2207C13.5488 13.9555 13.6542 13.7011 13.8417 13.5136C14.0293 13.3261 14.2836 13.2207 14.5488 13.2207H24.5488C24.814 13.2207 25.0684 13.3261 25.2559 13.5136C25.4435 13.7011 25.5488 13.9555 25.5488 14.2207V29.2207H27.5488V19.2207H30.5488C30.814 19.2207 31.0684 19.3261 31.2559 19.5136C31.4435 19.7011 31.5488 19.9555 31.5488 20.2207V29.2207ZM17.5488 21.2207V23.2207H21.5488V21.2207H17.5488ZM17.5488 17.2207V19.2207H21.5488V17.2207H17.5488Z",
    fill: "#782F11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10.5488 10.2207)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousing);
export default __webpack_public_path__ + "static/media/warehousing.198e422d98484c7e71ea62f1c3348e82.svg";
export { ForwardRef as ReactComponent };